import { handleActions } from "redux-actions";
import {
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getDateRanges,
  getRangeOptions,
  getSelectedRangeOption
} from "../../../../utils/date-range-options";

import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  DATA_SUCCESS,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_DATES,
  UPDATE_CUSTOM_RANGE,
  UPDATE_FILTER,
  UPDATE_DATES,
  RESET_SELECTED_FILTERS
} from "./staffGrossSalesSaga";

export const initialState = {
  initialRequest: false,
  filtersDirty: false,
  currentUser: {},
  isLoading: false,
  updatesLoading: false,
  filters: {},
  selectedFilters: {
    staffs: [],
    exclude_with_no_sales: { id: true, name: "YES" },
    include_deleted: { id: false, name: "NO" }
  },
  tableInfo: {},
  dataPoints: [],
  rangeOptions: [],
  requestDates: {},
  selectedRangeOption: null
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      initialRequest: true,
      currentUser: action.payload
    }),
    [DATA_SUCCESS]: (state, action) => ({
      ...state,
      tableInfo: action.payload.table_data,
      dataPoints: action.payload.data_points
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload,
      selectedFilters: {
        ...state.selectedFilters,
        staffs: action.payload.staffs
      }
    }),
    [UPDATE_FILTER]: (state, { payload: { key, data } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        [key]: data
      }
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      rangeOptions: getRangeOptions(action.payload.endDate, action.payload.calendarStartDate),
      selectedRangeOption: getSelectedRangeOption(action),
      requestDates: action.payload
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      requestDates: action.payload || state.requestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action)
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedRangeOption: action.payload,
      requestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      )
    }),
    [RESET_SELECTED_FILTERS]: (state) => ({
      ...state,
      selectedFilters: {
        ...initialState.selectedFilters,
        staffs: state.filters.staffs
      }
    })
  },
  initialState
);
